// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.viewer .v-img {\n  position: relative;\n}\n.viewer .v-img img {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
